export default __webpack_public_path__ + "static/media/currychickpeas@2x.51cc72af.jpg";